import request from '@utils/request'
import configRequest from "@src/config/request";

export const state = {
  cachedBrand: {},
  currentBrands: []
}

export const mutations = {
  CACHE_BRAND(state, currentBrand) {
    state.cachedBrand = currentBrand;
  }
}

export const actions = {
  /*
   * 取得單一品牌
   * */
  fetchBrand({ commit, getters }, { brandAlias }) {
    const cachedModule = state.cachedBrand;
    const hasCachedModule = !!cachedModule && state.cachedBrand.alias === brandAlias;
    return hasCachedModule
      ? cachedModule
      : request.get(`/brand/${ brandAlias }`,{
        ...configRequest,
        name: 'fetchBrand'
      })
        .then((response) => {
          commit('CACHE_BRAND', response.items);
        })
  },
  /*
   * 搜尋品牌
   * */
  fetchBrands({ commit }, {
    params
  } = {}) {
    return request.post(`/brand/search`, {
      ...params
    },{
      ...configRequest,
      name: 'fetchBrands'
    })
  },

  // /*
  // * 取得項目
  // * */
  // fetchItem({ commit }, { postType, itemAlias }) {
  //   return request
  //     .post(`/article/item/${itemAlias}`, {
  //       postType
  //     },{
  //       params: {
  //         postType
  //       }
  //     })
  // },
}
